export default "__VITE_ASSET__BvT02Wuf__"